import { useState } from 'react';
import { corporateFaqs } from '@/mocks/corporateData';
import { useTranslation } from 'react-i18next';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    speakable: {
      '@type': 'SpeakableSpecification',
      cssSelector: ['.faq-question', '.faq-answer'],
    },
    mainEntity: corporateFaqs.map((_faq, idx) => ({
      '@type': 'Question',
      name: t(`corporate.faq.q${idx + 1}`),
      acceptedAnswer: {
        '@type': 'Answer',
        text: t(`corporate.faq.a${idx + 1}`),
      },
    })),
  };

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />

      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          {String(t('corporate.faq.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporate.faq.title')}
          </h2>
          {String(t('corporate.faq.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="space-y-3">
          {corporateFaqs.map((_faq, idx) => (
            <div
              key={idx}
              className="border border-background-200/60 bg-background-100/60"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="faq-question text-[16px] text-foreground-800 tracking-[0.04em] font-medium pr-4">
                  {t(`corporate.faq.q${idx + 1}`)}
                </span>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-accent-500 text-sm transition-transform duration-300 ${
                      openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-[300px]' : 'max-h-0'
                }`}
              >
                <p className="faq-answer px-5 pb-5 text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed">
                  {t(`corporate.faq.a${idx + 1}`)}
                </p>
              </div>
            </div>
          ))}
        </div>

        {String(t('corporate.faq.otherNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-center text-[14px] text-foreground-400 tracking-[0.04em] mt-8">{__s}</p>))}
      </div>
    </section>
  );
}
